import { Component, OnInit, Input, EventEmitter, Output, OnDestroy } from '@angular/core';

import * as Services from '@shared/core/services';
import * as State from '@shared/state';
import { Controllers } from '@shared/core/controllers';

import { Observable } from 'rxjs';

@Component({
    template: '<div>This component requires extending</div>',
})
export class CartTypeComponent implements OnInit, OnDestroy {
    private _isScrollVisible: boolean = false;

    @Input() public emptyLabel: string = 'Your bag is empty';
    @Input() public maxHeight: number = 640;

    public pickupTimeLabel$: Observable<string>;
    public total$: Observable<number>;
    public cartItems$: Observable<Array<State.ICartMenuFlow | State.ICartSimpleItem>>;
    public cartEmptyLabelBtn$: Observable<string>;
    public isLocationDetailsPage$: Observable<boolean>;

    @Output() public onCloseClick: EventEmitter<Event> = new EventEmitter();

    constructor(
        public controllers: Controllers,
        public cartService: Services.CartService,
        public routeService: Services.RouteService
    ) { }

    ngOnInit(): void {
        this.pickupTimeLabel$ = this.controllers.cart.cartPickupTimeLabelFull$();
        this.total$ = this.controllers.cart.cartTotalValue$();
        this.cartItems$ = this.controllers.cart.getAllCartItemsSorted$();
        this.cartEmptyLabelBtn$ = this.controllers.cart.emptyBtnLabel$();
        this.isLocationDetailsPage$ = this.controllers.routes.isLocationDetailsPage$();

        this._bodyScrollLock(true);
    }

    ngOnDestroy() {
        this._bodyScrollLock(false);
    }

    public handleViewMenuClick($event: Event): Promise<boolean> {
        return this.handleOrderMoreClick($event);
    }

    public handleOrderMoreClick($event: Event): Promise<boolean> {
        this.cartService.hidePopup();

        return this.routeService.handleOrderMoreNavigation();
    }

    public handleCheckoutClick($event: Event): Promise<boolean> {

        return this.routeService.navigateToCheckout().then(() => this.cartService.hidePopup());
    }

    public handleClearCartClick($event: Event): void {
        // this.cartService.clearCart();
        this.controllers.cart.removeAllItems();
    }

    public handleScrollToggle(isVisible: boolean): void {
        this._isScrollVisible = isVisible;
    }

    public get isScrolling(): boolean {
        return this._isScrollVisible;
    }

    private _bodyScrollLock(lock: boolean): void {
        if (lock) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = null;
        }
    }
}
